import React from 'react';
import './StackedIconGroup.css';

const StackedIconGroup = ({children, className='', size='',  ...props}) => (
  <span {...props} className={`stacked-icon-group ${size} ${className}`} style={{position: 'relative'}}>
    {children}
  </span>
)

export {StackedIconGroup}